// THIS IS A GENERATED FILE
import * as Types from "../../graphql/types"

import gql from "graphql-tag"
import * as ApolloReactCommon from "@apollo/react-common"
import * as ApolloReactHooks from "@apollo/react-hooks"

export type ToggleBuildFlagMutationVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  userId: Types.Scalars["UUID"]
}>

export type ToggleBuildFlagMutation = { __typename?: "Mutation" } & {
  toggleBuildFlag?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message"
    >
  >
}

export type TogglePreviewBuildFlagMutationVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  userId: Types.Scalars["UUID"]
}>

export type TogglePreviewBuildFlagMutation = { __typename?: "Mutation" } & {
  togglePreviewBuildFlag?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message"
    >
  >
}

export type UpdatePreviewTriggerTypeMutationVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  triggerType: Types.PreviewTriggerType
}>

export type UpdatePreviewTriggerTypeMutation = { __typename?: "Mutation" } & {
  updatePreviewTriggerType?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message"
    >
  >
}

export const ToggleBuildFlagDocument = gql`
  mutation ToggleBuildFlag($siteId: UUID!, $userId: UUID!) {
    toggleBuildFlag(siteId: $siteId, userId: $userId) {
      success
      message
    }
  }
`
export type ToggleBuildFlagMutationFn = ApolloReactCommon.MutationFunction<
  ToggleBuildFlagMutation,
  ToggleBuildFlagMutationVariables
>

/**
 * __useToggleBuildFlagMutation__
 *
 * To run a mutation, you first call `useToggleBuildFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleBuildFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleBuildFlagMutation, { data, loading, error }] = useToggleBuildFlagMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleBuildFlagMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ToggleBuildFlagMutation,
    ToggleBuildFlagMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    ToggleBuildFlagMutation,
    ToggleBuildFlagMutationVariables
  >(ToggleBuildFlagDocument, baseOptions)
}
export type ToggleBuildFlagMutationHookResult = ReturnType<
  typeof useToggleBuildFlagMutation
>
export type ToggleBuildFlagMutationResult = ApolloReactCommon.MutationResult<
  ToggleBuildFlagMutation
>
export type ToggleBuildFlagMutationOptions = ApolloReactCommon.BaseMutationOptions<
  ToggleBuildFlagMutation,
  ToggleBuildFlagMutationVariables
>
export const TogglePreviewBuildFlagDocument = gql`
  mutation TogglePreviewBuildFlag($siteId: UUID!, $userId: UUID!) {
    togglePreviewBuildFlag(siteId: $siteId, userId: $userId) {
      success
      message
    }
  }
`
export type TogglePreviewBuildFlagMutationFn = ApolloReactCommon.MutationFunction<
  TogglePreviewBuildFlagMutation,
  TogglePreviewBuildFlagMutationVariables
>

/**
 * __useTogglePreviewBuildFlagMutation__
 *
 * To run a mutation, you first call `useTogglePreviewBuildFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePreviewBuildFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePreviewBuildFlagMutation, { data, loading, error }] = useTogglePreviewBuildFlagMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTogglePreviewBuildFlagMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    TogglePreviewBuildFlagMutation,
    TogglePreviewBuildFlagMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    TogglePreviewBuildFlagMutation,
    TogglePreviewBuildFlagMutationVariables
  >(TogglePreviewBuildFlagDocument, baseOptions)
}
export type TogglePreviewBuildFlagMutationHookResult = ReturnType<
  typeof useTogglePreviewBuildFlagMutation
>
export type TogglePreviewBuildFlagMutationResult = ApolloReactCommon.MutationResult<
  TogglePreviewBuildFlagMutation
>
export type TogglePreviewBuildFlagMutationOptions = ApolloReactCommon.BaseMutationOptions<
  TogglePreviewBuildFlagMutation,
  TogglePreviewBuildFlagMutationVariables
>
export const UpdatePreviewTriggerTypeDocument = gql`
  mutation UpdatePreviewTriggerType(
    $siteId: UUID!
    $triggerType: PreviewTriggerType!
  ) {
    updatePreviewTriggerType(siteId: $siteId, triggerType: $triggerType) {
      success
      message
    }
  }
`
export type UpdatePreviewTriggerTypeMutationFn = ApolloReactCommon.MutationFunction<
  UpdatePreviewTriggerTypeMutation,
  UpdatePreviewTriggerTypeMutationVariables
>

/**
 * __useUpdatePreviewTriggerTypeMutation__
 *
 * To run a mutation, you first call `useUpdatePreviewTriggerTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreviewTriggerTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreviewTriggerTypeMutation, { data, loading, error }] = useUpdatePreviewTriggerTypeMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      triggerType: // value for 'triggerType'
 *   },
 * });
 */
export function useUpdatePreviewTriggerTypeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePreviewTriggerTypeMutation,
    UpdatePreviewTriggerTypeMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdatePreviewTriggerTypeMutation,
    UpdatePreviewTriggerTypeMutationVariables
  >(UpdatePreviewTriggerTypeDocument, baseOptions)
}
export type UpdatePreviewTriggerTypeMutationHookResult = ReturnType<
  typeof useUpdatePreviewTriggerTypeMutation
>
export type UpdatePreviewTriggerTypeMutationResult = ApolloReactCommon.MutationResult<
  UpdatePreviewTriggerTypeMutation
>
export type UpdatePreviewTriggerTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdatePreviewTriggerTypeMutation,
  UpdatePreviewTriggerTypeMutationVariables
>
